
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Tag } from '@/types/tag';
import { debounce } from 'typescript-debounce-decorator';
import { searchTags } from '@/api/tags';
import { getSuggestedTags } from '@/api/images';

@Component({})
export default class TagDialog extends Vue {
  @Prop({ default: false })
  show!: boolean;
  @Prop() tags!: Tag[];
  @Prop() imageId!: string;

  isDirty: boolean = false;
  isLoading: boolean = false;
  matchingTags: string[] = [];
  currentTags: string[] = [];
  searchTerm: string = '';

  close() {
    if (this.isDirty) {
      this.$emit('updatetags', this.currentTags);
      this.isDirty = false;
    }
    this.$emit('update:show', false);
  }

  removeTag(name: string) {
    const index = this.currentTags.indexOf(name);
    this.currentTags.splice(index, 1);
    this.isDirty = true;
  }

  @Watch('searchTerm')
  @debounce(275, { leading: false })
  async onSearchTermChanged(newTerm: string) {
    this.isLoading = true;
    const result = await searchTags(newTerm);
    this.matchingTags = result.map(tag => tag.name);
    this.isLoading = false;
  }

  @Watch('show')
  async onShowChanged(newVal: boolean) {
    if (newVal && this.currentTags.length === 0) {
      this.isLoading = true;
      this.currentTags = await getSuggestedTags(this.imageId);
      this.isLoading = false;
      this.isDirty = true;
    }
  }

  @Watch('tags')
  async onTagsChanged(newTags: Tag[]) {
    this.currentTags = newTags.map(tag => tag.name);
  }
}
